(() => {
  const VariantSelects = customElements.get('variant-selects');
  if (!VariantSelects) return;

  VariantSelects.prototype.canvasUtil = function () {
    if (!this.closest('[data-step]')) return;
    const canvas = this.closest('[data-step]').querySelector('canvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let imageSrc, imageWidth, imageHeight;

    const tabsContainer = this.closest('[data-step]')?.querySelector('dynamic-form-tabs');
    const tabElements = tabsContainer ? Array.from(tabsContainer.querySelectorAll('[role^="tab-"]')) : [];
    const activeTabIndex = tabElements.findIndex(tab => tab.classList.contains('active'));
    const isLastTab = activeTabIndex === tabElements.length - 1;

    const activeTab = tabElements[activeTabIndex];
    const labelImage = activeTab?.dataset?.labelImage?.trim();
    const nonLabelImage = activeTab?.dataset?.nonLabelImage?.trim();
    const selectedLocationValue = this.querySelector('fieldset input[data-option-name*="location"]:checked')?.value?.toLowerCase() || '';
    const variantSideValue = this.variant?.option2?.toLowerCase() || '';
    const locationValue = selectedLocationValue || variantSideValue;
    const isBarSide = locationValue.includes('bar') || locationValue.includes('non-label');

    if (isLastTab) {
      const customImageSrc = activeTab?.dataset?.customImage?.trim();

      if (customImageSrc) {
        imageSrc = customImageSrc;
        imageWidth = null;
        imageHeight = null;
      }
    } else if (labelImage || nonLabelImage) {
      if (isBarSide && nonLabelImage) {
        imageSrc = nonLabelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      } else if (locationValue.includes('label') && labelImage) {
        imageSrc = labelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      } else if (labelImage) {
        imageSrc = labelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      } else if (nonLabelImage) {
        imageSrc = nonLabelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      }
    }

    if (!imageSrc) {
      imageSrc = canvas.dataset.imageSrc;
      imageWidth = canvas.dataset.imageWidth;
      imageHeight = canvas.dataset.imageHeight;
    }

    if (!imageSrc) return;

    imageSrc = imageSrc.trim();

    const bgImg = new Image();
    bgImg.crossOrigin = 'anonymous';
    bgImg.src = imageSrc;

    bgImg.onload = () => {
      if (!this.canvasData) return;

      if (isLastTab && !imageWidth && !imageHeight) {
        imageWidth = bgImg.naturalWidth;
        imageHeight = bgImg.naturalHeight;

        canvas.dataset.imageSrc = imageSrc;
        canvas.dataset.imageWidth = imageWidth;
        canvas.dataset.imageHeight = imageHeight;
      }

      canvas.width = +imageWidth;
      canvas.height = +imageHeight;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);

      const baseFontSize = 25 * (canvas.width / canvas.offsetWidth);
      const fontSize = isLastTab ? baseFontSize + 310 : baseFontSize;
      ctx.font = `${fontSize}px Helvetica`;
      ctx.textBaseline = 'middle';

      let color = '#000000';
      if (isLastTab) {
        color = '#FFFFFF';
      } else {
        const selectedSwatch = document.querySelector('.customizer-drawer .customizer-drawer__step:not(.hidden) .opt-btn:checked+.opt-label[data-swatch]');
        if (selectedSwatch) {
          color = getComputedStyle(selectedSwatch).getPropertyValue('--swatch-background-color').trim() || '#FFFFFF';
        }
      }
      ctx.fillStyle = color;

      const { text } = this.canvasData;
      if (!text) return;

      this.updateTextSourceActiveClass();

      const temp = document.createElement('div');
      temp.innerHTML = text;
      const span = temp.querySelector('.opt-label__text');
      const rawText = (span?.childNodes[0]?.textContent || text).trim().toUpperCase();

      const letterSpacing = isLastTab ? -15 : 0;
      const charWidths = [...rawText].map(ch => ctx.measureText(ch).width);
      const textWidth = charWidths.reduce((sum, w) => sum + w, 0) + letterSpacing * (rawText.length - 1);

      const imgEl = span?.querySelector('img');
      const hasIcon = !!imgEl?.src;
      const iconHeight = hasIcon ? fontSize : 0;
      const iconWidth = hasIcon ? (iconHeight * (imgEl.naturalWidth || 1) / (imgEl.naturalHeight || 1)) : 0;
      const padding = hasIcon ? 15 : 0;
      const showIconOnly = hasIcon;
      const totalWidth = showIconOnly ? iconWidth : (textWidth + padding + iconWidth);

      let xStart, textAlign;

      if (isLastTab) {
        xStart = 100;
        textAlign = 'left';
      } else {
        const selectedLocation = this.querySelector('fieldset input[data-option-name*="location"]:checked');
        const selectedLocationText = selectedLocation?.value?.toLowerCase() || '';
        if (selectedLocationText.includes('bar') || selectedLocationText.includes('non-label')) {
          xStart = 325;
          textAlign = 'left';
        } else {
          xStart = canvas.width - 345;
          textAlign = 'right';
        }
      }

      const drawX = textAlign === 'left' ? xStart : xStart - totalWidth;
      const yOffset = isLastTab ? 20 : 0;
      const textY = isLastTab ? canvas.height / 2 + yOffset : canvas.height / 2;

      if (!showIconOnly) {
        let currentX = drawX;
        rawText.split('').forEach((ch, i) => {
          ctx.fillText(ch, currentX, textY);
          currentX += charWidths[i] + letterSpacing;
        });
      }

      if (hasIcon) {
        let iconX;
        if (showIconOnly) {
          if (textAlign === 'left') {
            iconX = xStart;
          } else {
            const divisor = window.innerWidth > 768 ? 5 : 7;
            iconX = xStart - canvas.width / divisor;
          }
        }

        const icon = new Image();
        icon.crossOrigin = 'anonymous';
        icon.src = imgEl.src;

        icon.onload = () => {
          if (!icon.naturalHeight) return;

          const aspectRatio = icon.naturalWidth / icon.naturalHeight;
          const actualIconWidth = iconHeight * aspectRatio;
          const offCanvas = document.createElement('canvas');
          offCanvas.width = actualIconWidth;
          offCanvas.height = iconHeight;
          const offCtx = offCanvas.getContext('2d');
          offCtx.drawImage(icon, 0, 0, actualIconWidth, iconHeight);
          const imageData = offCtx.getImageData(0, 0, actualIconWidth, iconHeight);
          const data = imageData.data;

          let hex = color.replace('#', '');
          if (hex.length === 3) {
            hex = hex.split('').map(ch => ch + ch).join('');
          }
          const rNew = parseInt(hex.slice(0, 2), 16);
          const gNew = parseInt(hex.slice(2, 4), 16);
          const bNew = parseInt(hex.slice(4, 6), 16);

          for (let i = 0; i < data.length; i += 4) {
            data[i] = rNew;
            data[i + 1] = gNew;
            data[i + 2] = bNew;
          }
          offCtx.putImageData(imageData, 0, 0);

          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);

          if (!showIconOnly) {
            ctx.fillStyle = color;
            ctx.textAlign = 'left';
            let xChar = drawX;
            rawText.split('').forEach((ch, i) => {
              ctx.fillText(ch, xChar, textY);
              xChar += charWidths[i] + letterSpacing;
            });
          }

          const iconY = textY - iconHeight / 2;
          ctx.drawImage(offCanvas, iconX, iconY);
        };
      }
    };
  };
})();
